"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var stringDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createString: _factoriesAny.createString
};
exports.stringDependencies = stringDependencies;